export type IconProps = {
  /** Pixel size of the square viewBox (default 24). */
  size?: number;
  /** Accessible title — when omitted the icon is decorative (`aria-hidden`). */
  title?: string;
  className?: string;
};

export function iconA11y(title?: string): { 'aria-hidden': true } | { role: 'img'; 'aria-label': string } {
  if (title) {
    return { role: 'img', 'aria-label': title };
  }

  return { 'aria-hidden': true as const };
}
